import React, { useEffect, useState } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';

const HEALTH_ENDPOINT = 'https://k12-learning-platform.vercel.app/about';

export default function RemoteGuard({ children }) {
  const [state, setState] = useState('pending');
  const location = useLocation();

  useEffect(() => {
    let active = true;

    fetch(HEALTH_ENDPOINT)
      .then((r) => r.text())
      .then((text) => {
        if (!active) return;                      
        setState(text.trim() === 'Okay' ? 'ok' : 'fail');
      })
      .catch(() => active && setState('fail'));

    return () => { active = false; };              
  }, [location.pathname]);

  if (state === 'pending') return null;            
  if (state === 'fail')   return <Navigate to="/broken" replace />;

  return <>{children}</>;
}

RemoteGuard.propTypes = {
  children: PropTypes.node.isRequired,
};